import React from 'react'
import { ConfigProvider } from "antd";

import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import utils from '@/utils'
import 'animate.css'
import './style/base.css'
import './style/App.css'
import ProtectedRoute from './components/ProtectedRoute';
import locale from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import { LoadingProvider } from './contexts/LoadingContext';

import DefaultLayout from './containers'; // 直接导入
import AdminLayout from './containers/AdminLayout.jsx'; // 直接导入
import UserLayout from '@/viewsForUser/components/UserLayout';
import FooterTabs from '@/viewsForUser/components/FooterTabs';


dayjs.locale('zh-cn');

const { loadable } = utils;

// 基础页面
const View404 = loadable(() => import(/* webpackChunkName: '404' */ './views/Others/404'))
const View500 = loadable(() => import(/* webpackChunkName: '500' */ './views/Others/500'))
const Login = loadable(() => import(/* webpackChunkName: 'login' */ './views/Login'))

const Index = loadable(() => import(/* webpackChunkName: 'index' */ '@/views/Index'))

const Admin = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/Admin'))
const AdminCreate = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminCreate'))
const AdminEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminEdit'))
const AdminChangePassword = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminChangePassword'))

const Role = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/Role'))
const RoleEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Role/RoleEdit'))

const User = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/User'))
const UserEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/User/UserEdit'))

const QuickTask = loadable(() => import(/* webpackChunkName: 'QuickTask' */ '@/views/QuickTask'))
const QuickTaskEdit = loadable(() => import(/* webpackChunkName: 'QuickTaskEdit' */ '@/views/QuickTask/QuickTaskEdit'))

const Task = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Task'))
const TaskEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Task/TaskEdit'))
const TaskImage = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/TaskImage'))

const Order = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Order'))
const OrderEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Order/OrderEdit'))

const PaymentLog = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PaymentLog'))

const VipCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/VipCard'))
const VipCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/VipCard/VipCardEdit'))

const PointCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PointCard'))
const PointCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/PointCard/PointCardEdit'))

const Setting = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting'))
const SettingEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting/SettingEdit'))

const MemberLevelConfig = loadable(() => import(/* webpackChunkName: 'MemberLevelConfig' */ '@/views/MemberLevelConfig'))
const MemberLevelConfigEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/MemberLevelConfig/MemberLevelConfigEdit'))

const Label = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/Label'))
const LabelEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Label/LabelEdit'))

const ModelCategory = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelCategory'))
const ModelCategoryEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelCategory/ModelCategoryEdit'))

const ModelName = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelName'))
const ModelNameEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelName/ModelNameEdit'))

const ModelPicture = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelPicture'))
const ModelPictureEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelPicture/ModelPictureEdit'))

const Apikeys = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/views/Apikeys'))
const ApikeysEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Apikeys/ApikeysEdit'))

const SalesData = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/views/SalesData'))
const SalesDataEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/SalesData/SalesDataEdit'))

const Home = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/Home'))
const LoginWeChat = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/LoginWeChat'))
const LoginCallback = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/LoginCallback'))
const Tasks = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/Tasks'))
const TaskCreate = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/TaskCreate'))
const TaskDetail = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/TaskDetail'))
const Tuku = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/Tuku'))
const Social = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/Social'))
const SocialCreate = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/SocialCreate'))
const SocialDetail = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/SocialDetail'))
const SocialMyList = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/SocialMyList'))
const WebUser = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/User'))
const UserAgreement = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/UserAgreement')) // 用户服务协议
const UserPrivate = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/UserPrivate')) // 用户隐私条款
const UserComplete = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/UserComplete'))
const KeyCreate = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/KeyCreate'))
const VipPointCards = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/VipPointCards'))
const VipCards = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/VipCards'))
const WechatPayment = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/WechatPayment'))
const ShareKey = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/ShareKey'))
const ShareKeyEdit = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/ShareKey/ShareKeyEdit'))
const BindKey = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/viewsForUser/ShareKey/BindKey'))

const App = () => (
    <LoadingProvider>
        <ConfigProvider locale={locale}>
            <Router>
                <Routes>
                    <Route path='/500' element={<View500 />} />
                    <Route path='/admin_login' element={<Login />} />
                    <Route path='/404' element={<View404 />} />

                    {/* <Route path='/' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin', 'salesman']}>
                            <Navigate to='/index' replace />
                        </ProtectedRoute>
                    } /> */}
                    <Route path='/' element={
                        <Navigate to='/home' replace />
                    } />

                    <Route path='/index' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin', 'salesman']}>
                            <AdminLayout Component={Index}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/salesData' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin', 'salesman']}>
                            <AdminLayout Component={SalesData}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/salesData/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin', 'salesman']}>
                            <AdminLayout Component={SalesDataEdit}/>
                        </ProtectedRoute>
                    } />

                    <Route path='/admin' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Admin}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/admin/adminCreate' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={AdminCreate}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/admin/adminEdit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={AdminEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/admin/changePassword' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={AdminChangePassword}/>
                        </ProtectedRoute>
                    } />

                    <Route path='/role' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Role}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/role/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={RoleEdit}/>
                        </ProtectedRoute>
                    } />

                    <Route path='/user' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={User}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/user/userEdit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={UserEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/quickTask' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={QuickTask}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/quickTask/quickTaskEdit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={QuickTaskEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/task' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Task}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/task/taskEdit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={TaskEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/task_image' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={TaskImage}/>
                        </ProtectedRoute>
                    } />

                    <Route path='/order' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Order}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/order/orderEdit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={OrderEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/VipCard' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={VipCard}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/VipCard/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={VipCardEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/pointCard' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={PointCard}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/pointCard/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={PointCardEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/PaymentLog' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={PaymentLog}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/setting' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Setting}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/setting/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={SettingEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/MemberLevelConfig' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={MemberLevelConfig}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/MemberLevelConfig/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={MemberLevelConfigEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/label' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Label}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/label/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={LabelEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelCategory' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelCategory}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelCategory/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelCategoryEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelName' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelName}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelName/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelNameEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelPicture' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelPicture}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/modelPicture/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ModelPictureEdit}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/apikeys' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={Apikeys}/>
                        </ProtectedRoute>
                    } />
                    <Route path='/apikeys/edit' element={
                        <ProtectedRoute requiredRoles={['admin', 'superAdmin']}>
                            <AdminLayout Component={ApikeysEdit}/>
                        </ProtectedRoute>
                    } />
                    

                    <Route path='/login/wechat' element={<LoginWeChat />} />
                    <Route path='/login/wechat/callback' element={<LoginCallback />} />
                    <Route path='/home' element={<UserLayout>
                                <Home/>
                            </UserLayout>} />
                    
                    {/* <Route path='/home' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <Home/>
                            </UserLayout>
                        </ProtectedRoute>
                    } /> */}
                    <Route path='/web/tasks' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <Tasks/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/task-create' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <TaskCreate/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/task-detail/:id' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <TaskDetail/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />

                    <Route path='/web/social' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <Social/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/social/create' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <SocialCreate/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/social/detail' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <SocialDetail/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/social/myList' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <SocialMyList/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />

                    <Route path='/web/tuku' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <Tuku/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/user' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <WebUser/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    {/* <Route path='/web/user-agreement' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <UserAgreement/>
                            </UserLayout>
                        </ProtectedRoute>
                    } /> */}
                    <Route path='/web/user-agreement' element={
                        <UserLayout>
                            <UserAgreement/>
                        </UserLayout>
                    } />
                    <Route path='/web/user-private' element={
                        <UserLayout>
                            <UserPrivate/>
                        </UserLayout>
                    } />

                    <Route path='/web/user-complete' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <UserComplete/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/key-create' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <KeyCreate/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/vip-pointCards' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <VipPointCards/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/vip-info' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <VipCards/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />

                    <Route path='/web/wchatPayment' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <WechatPayment/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />

                    <Route path='/web/shareKey' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <ShareKey/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/shareKey/edit' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <ShareKeyEdit/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
                    <Route path='/web/shareKey/bind' element={
                        <ProtectedRoute requiredRoles={['user']}>
                            <UserLayout>
                                <BindKey/>
                            </UserLayout>
                        </ProtectedRoute>
                    } />
        
                    
                    {/* <Route component={DefaultLayout} /> */}

                    {/* 保护 DefaultLayout 下的所有路由 */}
                    {/* <Route path='/*' element={<ProtectedRoute />} /> */}
                    
                    {/* <Route path='/*' element={
                        <ProtectedRoute >
                            <DefaultLayout />
                        </ProtectedRoute>
                    } /> */}
                </Routes>
                {/* <FooterTabs/> */}
            </Router>
        </ConfigProvider>
    </LoadingProvider>
)

export default App
